import { lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { getLocalStorage } from "../utils";
import {
  ADMIN_ROUTES,
  BUILDER_ROUTES,
  AGENT_ROUTES,
  USER_ROUTES,
  SALES_ROUTES,
} from "../constants/appRoutes";
import PrivateRoute from "./PrivateRoute";
import AdminRoutes from "./AdminRoutes";
import Layout from "../layout";
import ResetPassword from "../pages/admin/Auth/ResetPassword";
import CustomerRoutes from "./CustomerRoutes";
import BuilderRoutes from "./BuilderRouters";
import AgentRoutes from "./AgentRoutes";
import { LOCAL_STORAGE_KEYS, ROLES } from "../constants";
import AuthorizationGaurd from "./AuthorizationGaurd";
import SalesRoutes from "./SalesRoutes";

const AdminLogin = lazy(() => import("../pages/admin/Auth/Login"));
const Home = lazy(() => import("../pages/customer/Home/HomePage"));

const isAuthenticated = getLocalStorage(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);

const Router = ({ serverProps }: any) => {
  return (
    <Routes>
      <Route path={USER_ROUTES.ROOT} element={<Layout />}>
        <Route index element={<Home serverProps={serverProps} />} />
        <Route
          path={`${ADMIN_ROUTES.ROOT}/*`}
          element={
            <PrivateRoute>
              <AuthorizationGaurd role={ROLES.ADMIN}>
                <AdminRoutes />
              </AuthorizationGaurd>
            </PrivateRoute>
          }
        />
        <Route
          path={`${ADMIN_ROUTES.ROOT}/*`}
          element={
            <PrivateRoute>
              <AuthorizationGaurd role={ROLES.STAFF}>
                <AdminRoutes />
              </AuthorizationGaurd>
            </PrivateRoute>
          }
        />
        <Route
          path={`${BUILDER_ROUTES.ROOT}/*`}
          element={
            <PrivateRoute>
              <AuthorizationGaurd role={ROLES.BUILDER}>
                <BuilderRoutes />
              </AuthorizationGaurd>
            </PrivateRoute>
          }
        />
        <Route
          path={`${AGENT_ROUTES.ROOT}/*`}
          element={
            <PrivateRoute>
              <AuthorizationGaurd role={ROLES.AGENT}>
                <AgentRoutes />
              </AuthorizationGaurd>
            </PrivateRoute>
          }
        />
        <Route
          path={`${SALES_ROUTES.ROOT}/*`}
          element={
            <PrivateRoute>
              <AuthorizationGaurd role={ROLES.SALES}>
                <SalesRoutes />
              </AuthorizationGaurd>
            </PrivateRoute>
          }
        />
        <Route
          path="/*"
          element={
            <AuthorizationGaurd role={ROLES.CUSTOMER}>
              <CustomerRoutes serverProps={serverProps} />
            </AuthorizationGaurd>
          }
        />
      </Route>
      <Route
        path={ADMIN_ROUTES.LOGIN}
        element={
          !isAuthenticated ? (
            <AdminLogin />
          ) : (
            <Navigate to={ADMIN_ROUTES.ROOT} />
          )
        }
      />
      <Route
        path={BUILDER_ROUTES.LOGIN}
        element={
          !isAuthenticated ? (
            <AdminLogin />
          ) : (
            <Navigate to={BUILDER_ROUTES.ROOT} />
          )
        }
      />
      <Route
        path={SALES_ROUTES.LOGIN}
        element={
          !isAuthenticated ? (
            <AdminLogin />
          ) : (
            <Navigate to={SALES_ROUTES.ROOT} />
          )
        }
      />
      <Route
        path={AGENT_ROUTES.LOGIN}
        element={
          !isAuthenticated ? (
            <AdminLogin />
          ) : (
            <Navigate to={AGENT_ROUTES.ROOT} />
          )
        }
      />

      {/* Reset password router defined */}
      <Route
        path={USER_ROUTES.RESET_PASSWORD}
        element={
          !isAuthenticated ? (
            <ResetPassword />
          ) : (
            <Navigate to={USER_ROUTES.ROOT} />
          )
        }
      />
      <Route
        path={ADMIN_ROUTES.RESET_PASSWORD}
        element={
          !isAuthenticated ? (
            <ResetPassword />
          ) : (
            <Navigate to={ADMIN_ROUTES.ROOT} />
          )
        }
      />
      <Route path={USER_ROUTES.NOT_FOUND} element={<h2>not found</h2>} />
    </Routes>
  );
};

export default Router;
